export default "/assets/images/housekeeping-service.29b578ade2a1b98e.webm";